import { call } from 'redux-saga/effects'

import api from 'Src/api'

const FETCH_ACCOUNT_URL = 'v1/account/'

export const fetchAccount = function* () {
  const response = yield call(api.get, FETCH_ACCOUNT_URL)
  return response.data
}
